<template>
  <v-row align="center" class="list px-3 mx-auto">
    <div class="submit-form mt-3 mx-auto">
      <div class="submit-form">
        <div class="form-group">
          <label for="className">Название класса</label>
          <input
            type="text"
            class="form-control"
            id="className"
            required
            v-model="sclass.className"
            name="className"
          />
        </div>
        <div class="form-group">
          <label for="classLider">Классный руководитель</label>
          <input
            type="text"
            class="form-control"
            id="classLider"
            required
            v-model="sclass.classLider"
            name="classLider"
          />
        </div>
        <div class="form-group">
          <label for="classLider">Пароль</label>
          <input
            type="text"
            class="form-control"
            id="classLider"
            required
            v-model="sclass.password"
            name="classLider"
          />
        </div>
        <br />
      </div>
      <div>
        Смена
        <select class="form-select" v-model="sclass.shiftSchool">
          <option
            v-for="cat in sShift"
            :key="cat.shiftSchool"
            v-bind:value="cat.shiftSchool"
          >
            {{ cat.shiftSchool }}
          </option>
        </select>
        Уровень образования:
        <select class="form-select" v-model="sclass.levelEdu">
          <option value="1">Начальное</option>
          <option value="2">Основное</option>
          <option value="3">Среднее</option>
        </select>
      </div>
      <br />
      <div style="display: flex; justify-content: center; padding: 0 0 10px 0">
        <button
          @click="create"
          class="btn btn-success"
          style="width: 500px; padding: 10px"
        >
          Создать класс
        </button>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          padding: 0 0 10px 0;
        "
      >
        <button
          @click="importClass()"
          class="btn btn-dark"
          style="width: 500px; margin-right: 5px"
        >
          Импорт классов
        </button>
        <button
          @click="importStudents()"
          class="btn btn-dark"
          style="width: 500px; margin-left: 5px"
        >
          Импорт учеников
        </button>
      </div>
      <div style="display: flex; justify-content: center; padding: 0 0 10px 0">
        <button
          type="button"
          class="btn btn-primary"
          @click="toDataStudents()"
          aria-label="Close modal"
          style="color: white"
        >
          Данные учеников
        </button>
      </div>
      <!-- Новая кнопка для массового обновления паролей -->
      <div style="display: flex; justify-content: center; padding: 10px 0">
        <button
          @click="updateAllPasswords"
          class="btn btn-warning"
          style="width: 500px; padding: 10px"
          :disabled="isUpdating"
        >
          {{
            isUpdating ? "Обновление..." : "Обновить пароли для всех классов"
          }}
        </button>
      </div>
    </div>
    <br />
    <div>
      <v-col>
        <v-card>
          <v-card-title>Список классов</v-card-title>

          <v-data-table
            :headers="headers"
            :items="sclass"
            :items-per-page="100"
            hide-default-footer
          >
            <template v-slot:[`item.actions`]="{ item }">
              <div class="select-flex">
                <select
                  class="form-select"
                  name=""
                  id=""
                  v-model="item.levelEdu"
                >
                  <option value="1">Начальное</option>
                  <option value="2">Основное</option>
                  <option value="3">Среднее</option>
                </select>
                <div class="select">
                  <button
                    class="btn btn-success"
                    style="margin-right: 10px"
                    @click="updateLevelEdu(item)"
                  >
                    Обновить Уровень образования
                  </button>
                </div>
                <div class="select" style="padding-right: 20px">
                  <input
                    type="text"
                    class="form-control"
                    required
                    v-model="item.passwordChange"
                    name="classLider"
                    v-bind:id="item.id"
                    style="padding-right: 20px; width: 150px"
                  />
                </div>

                <div class="select">
                  <button class="btn btn-success" @click="updatePassword(item)">
                    Обновить пароль
                  </button>
                </div>

                <v-card-actions>
                  <button class="btn btn-danger" @click="deleteClass(item.id)">
                    Удалить
                  </button>
                </v-card-actions>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </div>

    <!-- Модальное окно для отображения новых паролей -->
    <div v-if="showPasswordModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Новые пароли для классов</h3>
          <button class="close-btn" @click="closePasswordModal">×</button>
        </div>
        <div class="modal-body">
          <table class="password-table">
            <thead>
              <tr>
                <th>Класс</th>
                <th>Новый пароль</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in updatedPasswords" :key="item.className">
                <td>{{ item.className }}</td>
                <td>{{ item.newPassword }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="printPasswordTable">
            🖨️ Печать
          </button>
          <button class="btn btn-success" @click="copyPasswords">
            📋 Копировать
          </button>
          <button class="btn btn-secondary" @click="closePasswordModal">
            Закрыть
          </button>
        </div>
      </div>
    </div>

    <modal v-show="showModalCheck" @close="importStudents()" />
    <importClass v-show="showImportClass" @close="importClass()" />
  </v-row>
</template>

<style>
@import "../assets/style.css";

/* Стили для модального окна */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.password-table {
  width: 100%;
  border-collapse: collapse;
}

.password-table th,
.password-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
}

.password-table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.password-table tr:hover {
  background-color: #f5f5f5;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-footer .btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.modal-footer .btn-primary {
  background-color: #007bff;
  color: white;
}

.modal-footer .btn-success {
  background-color: #28a745;
  color: white;
}

.modal-footer .btn-secondary {
  background-color: #6c757d;
  color: white;
}

.modal-footer .btn:hover {
  opacity: 0.9;
}

/* Стили для печати */
@media print {
  .modal-overlay {
    position: static;
    background: white;
  }

  .modal-content {
    max-width: 100%;
    width: 100%;
    height: 100vh;
    border-radius: 0;
    box-shadow: none;
  }

  .modal-header .close-btn,
  .modal-footer .btn {
    display: none !important;
  }

  .modal-footer {
    justify-content: center !important;
  }
}
</style>

<script>
import modal from "./importStudents.vue";
import importClass from "./importClass.vue";
import TutorialDataService from "../services/TutorialDataService";
import ServerCommandLogin from "../services/ServerCommandLogin";

export default {
  components: { modal, importClass },

  name: "tutorials-list",
  data() {
    return {
      sShift: [{ shiftSchool: "1 смена" }, { shiftSchool: "2 смена" }],
      sclass: [],
      title: "",
      headers: [
        { text: "Класс", align: "start", sortable: true, value: "className" },
        { text: "Классный руководитель", value: "classLider", sortable: false },
        { text: "Смена", value: "shiftSchool", sortable: false },
        { text: "Уровень", value: "level", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      showModalCheck: false,
      showImportClass: false,
      showPasswordModal: false,
      updatedPasswords: [],
      isUpdating: false,
    };
  },
  methods: {
    // Генерация случайного числа из 6 цифр
    generateRandomNumber() {
      return Math.floor(100000 + Math.random() * 900000).toString();
    },

    // Генерация нового пароля
    generatePassword(className) {
      const cleanName = className.replace(/\s+/g, ""); // Убираем пробелы
      return `${cleanName}${this.generateRandomNumber()}`;
    },

    // Массовое обновление паролей
    async updateAllPasswords() {
      if (this.sclass.length === 0) {
        alert("Нет классов для обновления паролей");
        return;
      }

      this.isUpdating = true;
      this.updatedPasswords = [];
      let successCount = 0;
      let errorCount = 0;

      try {
        for (const classItem of this.sclass) {
          const newPassword = this.generatePassword(classItem.className);

          const sendData = {
            id: classItem.id,
            passwordChange: newPassword,
            className: classItem.className,
          };

          try {
            await ServerCommandLogin.updatePassword(classItem.id, sendData);
            successCount++;
            this.updatedPasswords.push({
              className: classItem.className,
              newPassword: newPassword,
            });
            // Обновляем локальное состояние
            classItem.passwordChange = newPassword;
          } catch (error) {
            console.error(
              `Ошибка обновления пароля для класса ${classItem.className}:`,
              error,
            );
            errorCount++;
          }
        }

        // Показываем модальное окно с результатами
        if (this.updatedPasswords.length > 0) {
          this.showPasswordModal = true;
        }

        // Выводим итоговое сообщение
        let message = `Обновление паролей завершено!\n`;
        message += `✅ Успешно: ${successCount} классов\n`;
        if (errorCount > 0) {
          message += `❌ Ошибок: ${errorCount} классов`;
        }
        alert(message);
      } catch (error) {
        console.error("Ошибка при массовом обновлении паролей:", error);
        alert("Произошла ошибка при обновлении паролей");
      } finally {
        this.isUpdating = false;
        // Обновляем список классов
        this.refreshList();
      }
    },

    // Закрыть модальное окно с паролями
    closePasswordModal() {
      this.showPasswordModal = false;
    },

    // Копировать пароли в буфер обмена
    async copyPasswords() {
      let text = "Новые пароли для классов:\n\n";
      this.updatedPasswords.forEach((item) => {
        text += `${item.className}: ${item.newPassword}\n`;
      });

      try {
        await navigator.clipboard.writeText(text);
        alert("Пароли скопированы в буфер обмена!");
      } catch (err) {
        // Fallback для старых браузеров
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("Пароли скопированы в буфер обмена!");
      }
    },

    printPasswordTable() {
      // Создаем содержимое только для печати
      const printContent = `
    <div style="padding: 20px; font-family: Arial, sans-serif;">
      <h2 style="text-align: center; margin-bottom: 20px;">Новые пароли для классов</h2>
      <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr style="background-color: #f2f2f2;">
            <th style="border: 1px solid #ddd; padding: 12px; text-align: left;">Класс</th>
            <th style="border: 1px solid #ddd; padding: 12px; text-align: left;">Новый пароль</th>
          </tr>
        </thead>
        <tbody>
          ${this.updatedPasswords
            .map(
              (item) => `
            <tr>
              <td style="border: 1px solid #ddd; padding: 10px;">${item.className}</td>
              <td style="border: 1px solid #ddd; padding: 10px; font-weight: bold; font-family: monospace;">${item.newPassword}</td>
            </tr>
          `,
            )
            .join("")}
        </tbody>
      </table>
      <p style="text-align: center; margin-top: 30px; color: #666; font-size: 14px;">
        Дата генерации: ${new Date().toLocaleString()}
      </p>
    </div>
  `;

      // Открываем новое окно для печати
      const printWindow = window.open("", "_blank");
      const htmlContent =
        `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Новые пароли для классов</title>
        <style>
          body { 
            margin: 0; 
            padding: 20px; 
            font-family: Arial, sans-serif;
          }
          @page {
            size: portrait;
            margin: 2cm;
          }
          @media print {
            body { 
              background: white;
              padding: 0;
            }
          }
        </style>
      </head>
      <body>
        ${printContent}
        <script>
          window.onload = function() {
            // Запускаем печать
            window.print();
          };
          
          // Закрываем окно после печати
          window.onafterprint = function() {
            setTimeout(function() {
              window.close();
            }, 500);
          };
        <` +
        `/script>
      </body>
    </html>
  `;

      printWindow.document.write(htmlContent);
      printWindow.document.close();
    },

    toDataStudents() {
      this.$router.push("/DataStudents");
    },
    importStudents() {
      this.showModalCheck = !this.showModalCheck;
    },
    importClass() {
      this.showImportClass = !this.showImportClass;
    },

    updateLevelEdu(data) {
      let sendData = {
        id: data.id,
        level: data.levelEdu,
        className: data.className,
      };
      TutorialDataService.updateLevelEduClass(data.id, sendData)
        .then((response) => {
          console.log(response.data);
          alert("Уровень образования изменен!");
          for (let i = 0; i < this.sclass.length; i++) {
            if (sendData.id === this.sclass[i].id) {
              this.sclass[i].level = sendData.level;
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    updatePassword(data) {
      console.log(data);
      let sendData = {
        id: data.id,
        passwordChange: data.passwordChange,
        className: data.className,
      };
      console.log(sendData);

      ServerCommandLogin.updatePassword(data.id, sendData)
        .then((response) => {
          console.log(response.data);
          alert("Пароль успешно изменен");
        })
        .catch((e) => {
          console.log(e);
        });
    },
    create() {
      var data = {
        className: this.sclass.className,
        classLider: this.sclass.classLider,
        shiftSchool: this.sclass.shiftSchool,
        password: this.sclass.password,
        level: this.sclass.levelEdu,
      };

      TutorialDataService.createClass(data)
        .then((response) => {
          this.sclass.id = response.data.id;

          console.log("УСПЕШНО ОТПРАВЛЕНО", response.data.id);
          this.refreshList();
        })
        .catch((e) => {
          console.log("1111111111", e);
        });
    },

    deleteClass(id) {
      console.log("ID============", id);
      TutorialDataService.delete(id)
        .then(() => {
          this.refreshList();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    retrieveTutorials() {
      TutorialDataService.getAllCLass()
        .then((response) => {
          this.sclass = response.data.map(this.getDisplayTutorial);
          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    refreshList() {
      this.retrieveTutorials();
    },

    getDisplayTutorial(data) {
      return {
        id: data._id,
        className: data.className,
        classLider: data.classLider,
        shiftSchool: data.shift,
        level: data.level,
        levelEdu: "",
      };
    },
  },
  mounted() {
    this.retrieveTutorials();
  },
};
</script>

<style>
.submit-form {
  max-width: 300px;
}
/* Стили для печати */
@media print {
  .modal-overlay {
    display: none !important;
  }
}

/* Дополнительные стили для печати в новом окне */
.password-print-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.password-print-table th,
.password-print-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.password-print-table th {
  background-color: #f2f2f2;
  font-weight: 600;
}

.password-print-table td:last-child {
  font-family: monospace;
  font-weight: bold;
  font-size: 16px;
}
</style>
